import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperOptions = {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        spaceBetween: 5,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            1240: {
                slidesOffsetAfter: 125,
                slidesOffsetBefore: 0,
            },
            992: {
                slidesOffsetBefore: 0,
            },
            768: {
                slidesOffsetAfter: 60,
                slidesOffsetBefore: 60,
            }
        }
    };

    element.swiper = new Swiper(element.querySelector(".join-swiper"), swiperOptions);
};